// Central list of all achievements and how they're earned.
// Keep this file dumb: metadata + trigger definitions only.
// The runtime (AchievementsProvider) decides how to listen and when to unlock.

const STATIC_ACHIEVEMENTS = [
{
    id: 'test-press-9',
    name: 'Test Secret',
    description: 'This is a test for the secrets system!',
    iconSrc: '/Secrets Icons/SecretTest.png',
    earnedBy:
    {
        type: 'key',
        key: '9',
        code: 'Digit9',
    },
    // Requested filename is "AchievmentSpecial.ogg" (typo). The site already contains
    // "AchievementSpecial.ogg" in /public/Audio, so we support both.
    soundCandidates: ['/Audio/AchievmentSpecial.ogg', '/Audio/AchievementSpecial.ogg'],
},
{
    id: 'test-generic-secret',
    name: 'Test Generic Secret',
    description: 'This is a test for the secrets system!',
    iconSrc: '/Secrets Icons/SecretTest.png',
    earnedBy:
    {
        type: 'key',
        key: '8',
        code: 'Digit8',
    },
    // Override: generic unlock sound
    unlockSoundCandidates: ['/Audio/AchievementGeneric.ogg'],
},
{
    id: 'boop-ari-nose',
    name: 'Boop!',
    description: "You booped Ari's nose.",
    iconSrc: '/Secrets Icons/SecretBoop.png',
    earnedBy:
    {
        type: 'event',
        eventName: 'ari-nose-booped',
    },
},
{
    id: 'great-listener',
    name: 'Great Listener',
    description: 'Read everything that i have to say!',
    iconSrc: '/Secrets Icons/SecretYapper.png',
    earnedBy:
    {
        type: 'event',
        eventName: 'main-messages-cycle-complete',
    },
},
{
    id: 'secret-entry',
    name: 'Secret Entry',
    description: "There's a little more to me I dont show to everyone",
    iconSrc: '/Secrets Icons/SecretAboutMeFolder.png',
    earnedBy:
    {
        type: 'event',
        eventName: 'aboutme-secret-entered',
        delayMs: 1000,
    },
},
];

// Generate achievements for discovering each class (except Ari, the default).
// This is called when goobers data is loaded, and returns all achievements combined.
export function buildAchievements(goobersList)
{
    let discoveries = [];

    if (Array.isArray(goobersList))
    {
        // Skip the first class (usually Ari) - no achievement needed for the default.
        // For the rest, create a discovery achievement.
        for (let i = 1; i < goobersList.length; i++)
        {
            const goober = goobersList[i];
            if (!goober || !goober.name) continue;

            const className = String(goober.name);
            discoveries.push({
                id: `discover-${className.toLowerCase()}`,
                name: `Meet ${className}`,
                description: `Discovered ${className}!`,
                iconSrc: '/Secrets Icons/SecretTest.png', // Default icon; can be customized per class later
                earnedBy:
                {
                    type: 'event',
                    eventName: `class-discovered-${className.toLowerCase()}`,
                },
            });
        }
    }

    return [...STATIC_ACHIEVEMENTS, ...discoveries];
}

export let ACHIEVEMENTS = STATIC_ACHIEVEMENTS;

// Update the global ACHIEVEMENTS list when goobers are loaded.
export function updateAchievementsWithGoobers(goobersList)
{
    ACHIEVEMENTS = buildAchievements(goobersList);
}

export function getAchievementById(id)
{
    return ACHIEVEMENTS.find((a) => a.id === id) || null;
}
